import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch} from 'react-router-dom';
import QvrfComponent from './QvrfComponent';
import QvrfContainer from 'components/qvrf_component/QvrfContainer';
import { makeQsOptions, pageLoadingStatus } from 'utils/Helper';

const QlikSelectionsMenu = () => {
    const [qsOptions, setQsOptions] = useState(null);
    const [currentPage, setCurrentPage] = useState(null);
    const { path } = useRouteMatch();
    const { page } = useSelector((state) => state.pages);
    const { publicAccess } = useSelector((state) => state.settings);
    const { qsServer } = useSelector((state) => state.qsServer);
    const { isAuthenticated } = useSelector((state) => state.auth);

    const isLoading = useSelector((state) => pageLoadingStatus(state));

    const qsServerSetup = () => {
        if (qsServer) {
            const qsServerOptions = makeQsOptions(
                qsServer,
                isAuthenticated,
                publicAccess
            );
            setQsOptions({
                ...qsServerOptions,
                config: {
                    ...qsServerOptions.config,
                    appId: currentPage?.qsApp,
                },
            });
        }
    };

    const getCurrentDynamicPageDetails = () => {
        const pageDetails = { ...page.page };
        if (page?.dynamicApp) {
            pageDetails.qsApp = page?.dynamicApp?.qsApp;
        }
        return pageDetails;
    }

    useEffect(() => {
        if (page && currentPage?._id !== page?.page?._id) {
            const pageDetails = getCurrentDynamicPageDetails();
            setCurrentPage(pageDetails);
        }
    }, [page]);

    useEffect(() => {
        qsServerSetup();
    }, [qsServer, currentPage]);

    if (path !== '/pages/:id') {
        return '';
    }

    if (isLoading || !currentPage || !qsOptions || !qsOptions?.config?.appId) {
        return '';
    }

    return (
        <QvrfContainer config={qsOptions.config} loaderHeight={110} showSkeleton={false}>
            <QvrfComponent
                options={qsOptions}
                type="qDocSelectionsToolbar"
                props={{
                    type: 'QdtSelectionToolbar',
                    title: 'Selections',
                    btnText: 'Clear All',
                }}
            />
        </QvrfContainer>
    );
};

export default QlikSelectionsMenu;
